var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_57)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.26 14.35C21.81 14.89 21.14 15.21 20.43 15.21H2.37999C1.66999 15.21 1.00999 14.9 0.549988 14.35L9.26999 7.09L10.17 7.71C10.91 8.22 11.9 8.22 12.64 7.71L13.54 7.09L22.26 14.35Z",
    fill: "#1E88E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4 1.04L13.55 7.1L12.65 7.72C11.91 8.23 10.92 8.23 10.18 7.72L9.27998 7.1L0.419983 1.03C0.859983 0.38 1.59998 0 2.37998 0H20.44C21.23 0 21.96 0.38 22.4 1.04Z",
    fill: "#64B5F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.27 7.09L0.55 14.35C0.19 13.93 0 13.39 0 12.83V2.38C0 1.9 0.14 1.43 0.42 1.03L9.27 7.1V7.09Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.82 2.38001V12.84C22.82 13.4 22.63 13.93 22.27 14.36L13.55 7.10001L22.4 1.04001C22.67 1.43001 22.82 1.90001 22.82 2.38001Z",
    fill: "#2196F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_57"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.82,
    height: 15.21,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail);
export default __webpack_public_path__ + "static/media/iconMail.6d068060a07c4a8a47f4c50208e63bbf.svg";
export { ForwardRef as ReactComponent };